export default __webpack_public_path__ + "static/media/man-shirt-torso.24d69889.jpg";